import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineDrinksIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" fillRule="evenodd" d="M3 2a1 1 0 0 0-.8107 1.5855L8.5 12.3233V19H5c-.5523 0-1 .4477-1 1s.4477 1 1 1h6c.5523 0 1-.4477 1-1s-.4477-1-1-1h-.5v-6.6766l6.3107-8.738A1 1 0 0 0 16 2H3Zm3.4002 4L4.9558 4h9.0884l-1.4444 2H6.4002ZM9.5 10.292 7.8446 8h3.3108L9.5 10.292Z" clipRule="evenodd"/>
    <path fill="currentColor" fillRule="evenodd" d="M12.7503 12.3382A1.0003 1.0003 0 0 1 13.5 12H21a1.0002 1.0002 0 0 1 .9923 1.124l-.4984 3.9873a1.2588 1.2588 0 0 1-.0035.028l-.4981 3.9847A1 1 0 0 1 20 22h-5.5a1 1 0 0 1-.9923-.876l-.498-3.9839c-.0013-.0099-.0026-.0197-.0037-.0296l-.4983-3.9865a1.0003 1.0003 0 0 1 .2426-.7858ZM19.8672 14l-.25 2h-4.7344l-.25-2h5.2344Zm-.75 6h-3.7344l-.25-2h4.2344l-.25 2Z" clipRule="evenodd"/>
  </SvgIcon>
}

export default LineDrinksIcon
